<template>
  <v-modal :active="active" @close="$emit('close')" wideWidth>
    <div v-if="event == null" v-padding="5">
      <v-spinner block />
    </div>
    <div v-else v-padding="3">
      <v-row :class="theme.borderBottom" v-padding.bottom="2">
        <v-col default="9">
          <div v-text-align.left>
            <v-text v-if="event.companyName" type="headline">{{ event.companyName }}</v-text>
            <v-text v-else type="headline">{{ getFullName(event) }}</v-text>
          </div>
        </v-col>
        <v-col default="2" v-text-align.right v-margin.top="1"></v-col>
        <v-col default="1" v-text-align.center>
          <v-icon-button @click="$emit('close')">clear</v-icon-button>
        </v-col>
      </v-row>
      <section :class="theme.borderBottom" v-padding.bottom="4">
        <div v-margin.top="3">
          <div>
            <v-text type="subheadling" bold>Мониторинг</v-text>
          </div>
          <div v-margin.top="2" :class="theme.infoBlock">
            <div :class="theme.info" v-margin.right="3">
              <div v-margin.bottom="1">
                <v-text bold>Статус</v-text>
              </div>
              <div>
                <v-text v-if="event.isActive">
                  <span :class="theme.active"></span> Активен
                </v-text>
                <v-text v-else>
                  <span :class="theme.inactive"></span> Не активен
                </v-text>
              </div>
            </div>
            <div :class="theme.info" v-margin.right="3">
              <div v-margin.bottom="1">
                <v-text bold>Дата начала</v-text>
              </div>
              <div>
                <v-text>{{ moment(event.monitoringStart).format('DD.MM.YYYY') }}</v-text>
              </div>
            </div>

            <div :class="theme.info" v-margin.right="3">
              <div v-margin.bottom="1">
                <v-text bold>Дата окончания</v-text>
              </div>
              <div>
                <v-text>{{ moment(event.monitoringEnd).format('DD.MM.YYYY') }}</v-text>
              </div>
            </div>

            <div :class="theme.create" style="margin-left: auto;">
              <v-router-link :to="{
                name: 'monitoringRenewal',
                query: {
                  renewal: 'true',
                  type: event.isJuridical ? 'juridical' : 'individual',
                  lastName: event.lastName,
                  firstName: event.firstName,
                  middleName: event.middleName,
                  dateBirth: formatBirthDate(event.birthDate),
                  passportSeries: event.passportSeries,
                  passportNumber: event.passportNumber,
                  currentMonitoringEnd: currentMonitoringEnd,
                  monitoringId: event.id
                }
              }" @click.native="$emit('close')">
                <v-button primary>
                  Продлить
                </v-button>
              </v-router-link>
            </div>

          </div>
        </div>
      </section>
      <section v-margin.top="2" v-margin.bottom="2">
        <v-row>
          <v-col xs="10">
            <v-text type="headline">События</v-text>
          </v-col>
          <v-col v-text-align.right>
            <v-text type="caption">Всего: {{ event.monitoringEvents.length }}</v-text>
          </v-col>
        </v-row>
      </section>
      <template>
        <v-panel>
          <v-tabs :tabs="tabs" :selected="selectedTab" @click="(e) => changeTab(e)" />
        </v-panel>
      </template>
      <section v-margin.top="3" :class="theme.signalsContainer">
        <div :class="theme.signalsContent">
          <v-data-table v-if="selectedTab == 'credits'" @sort="$emit('sort', $event)" :sort="sort"
            :headers="creditHeaders" :records="events" rowAction>

            <template slot="cell-name" scope="props">
              <v-text>{{ formatItemName(props.item.name) }}</v-text>
            </template>

            <template slot="cell-date" scope="props">
              <v-text nowrap>{{ moment(props.item.credit.date).format('DD.MM.YYYY') }}</v-text>
            </template>

            <template slot="cell-typeName" scope="props">
              {{ props.item.credit.loanTypeText }}
              <v-text v-if="props.item.credit.typeName">
                <br/>             
                <b>Цель:</b> {{ props.item.credit.typeName }}
              </v-text>
            </template>

            <template slot="cell-openDate" scope="props">
              <v-text nowrap>{{ props.item.credit.openDate ? moment(props.item.credit.openDate).format('DD.MM.YYYY') :
                '&mdash;' }}</v-text>
            </template>

            <template slot="cell-closePlanDate" scope="props">
              <v-text nowrap>{{ props.item.credit.closePlanDate ?
                moment(props.item.credit.closePlanDate).format('DD.MM.YYYY') : '&mdash;' }}</v-text>
            </template>

            <template slot="cell-closeFactDate" scope="props">
              <v-text nowrap>{{ props.item.credit.closeFactDate ?
                moment(props.item.credit.closeFactDate).format('DD.MM.YYYY') : '&mdash;' }}</v-text>
            </template>

            <template slot="cell-status" scope="props">
              <v-text nowrap>{{ props.item.credit.status ? 'Закрыт' : 'Открыт' }}</v-text>
            </template>

            <template slot="cell-pastDue" scope="props">
              <div v-if="props.item.credit">
                <div>Cумма просрочки: {{ props.item.credit.pastDue ?
                  `${numberWithSpaces(props.item.credit.pastDue)} ${props.item.credit.currency}` : '&mdash;' }}</div>
                <div>Срок просрочки: {{ props.item.credit.pastDueDays ? props.item.credit.pastDueDays : '&mdash;' }}
                </div>
              </div>
              <v-text v-else nowrap>&mdash;</v-text>
            </template>

            <template slot="cell-limit" scope="props">
              <div v-if="props.item.credit">
                <div>Лимит: {{ props.item.credit.limit ? `${numberWithSpaces(props.item.credit.limit)}
                  ${props.item.credit.currency}` : '&mdash;' }}</div>
                <div>Выплачено: {{ props.item.credit.balance ?
                  `${numberWithSpaces(props.item.credit.balance)} ${props.item.credit.currency}` : '&mdash;' }}
                </div>
                <div>Осталось: {{ props.item.credit.outstanding ?
                  `${numberWithSpaces(props.item.credit.outstanding)} ${props.item.credit.currency}` : '&mdash;' }}
                </div>
                <div>След. платеж: {{ props.item.credit.nextPayment ?
                  `${numberWithSpaces(props.item.credit.nextPayment)} ${props.item.credit.currency}` : '&mdash;' }}
                </div>
              </div>
              <v-text v-else nowrap>&mdash;</v-text>
            </template>
          </v-data-table>

          <v-data-table v-if="selectedTab == 'inquiries'" @sort="$emit('sort', $event)" :sort="sort"
            :headers="inquiryHeaders" :records="events" rowAction>
            <template slot="cell-name" scope="props">
              <v-text nowrap>{{ formatItemName(props.item.name) }}</v-text>
            </template>
            <template slot="cell-date" scope="props">
              <v-text nowrap>{{ moment(props.item.inquiry.date).format('DD.MM.YYYY') }}</v-text>
            </template>
            <template slot="cell-purposeName" scope="props">
              <v-text>{{ props.item.inquiry.purposeName }}</v-text>
            </template>
            <template slot="cell-amount" scope="props">
              <v-text nowrap>{{ `${numberWithSpaces(props.item.inquiry.amount)} ${props.item.credit.currency}`
                }}</v-text>
            </template>
          </v-data-table>

          <v-data-table v-if="selectedTab == 'bankrupts'" @sort="$emit('sort', $event)" :sort="sort"
            :headers="bankruptHeaders" :records="events" rowAction>
            <template slot="cell-name" scope="props">
              <v-text nowrap>{{ formatItemName(props.item.name) }}</v-text>
            </template>
            <template slot="cell-date" scope="props">
              <v-text nowrap>{{ moment(props.item.bankrupt.date).format('DD.MM.YYYY') }}</v-text>
            </template>
            <template slot="cell-codeText" scope="props">
              <v-text nowrap>{{ props.item.bankrupt.codeText ? props.item.bankrupt.codeText : '&mdash;' }}</v-text>
            </template>
            <template slot="cell-stageText" scope="props">
              <v-text nowrap>{{ props.item.bankrupt.stageText ? props.item.bankrupt.stageText : '&mdash;' }}</v-text>
            </template>
            <template slot="cell-number" scope="props">
              <v-text nowrap>{{ props.item.bankrupt.number ? props.item.bankrupt.number : '&mdash;' }}</v-text>
            </template>
          </v-data-table>

          <v-data-table v-if="selectedTab == 'applications'" @sort="$emit('sort', $event)" :sort="sort"
            :headers="applicationHeaders" :records="events" rowAction>
            <template slot="cell-name" scope="props">
              <v-text>{{ formatItemName(props.item.name) }}</v-text>
            </template>
            <template slot="cell-date" scope="props">
              <v-text nowrap>{{ moment(props.item.application.date).format('DD.MM.YYYY') }}</v-text>
            </template>
            <template slot="cell-contactingCodeText" scope="props">
              <v-text>{{ props.item.application.contactingCodeText }}</v-text>
            </template>
            <template slot="cell-stageText" scope="props">
              <v-text>
                {{ props.item.application.stageText }}
                <v-text v-if="props.item.application.rejectionReasonText">
                  <br/>
                  <b>Причина:</b> {{ props.item.application.rejectionReasonText }}
                </v-text>
              </v-text>
            </template>
            <template slot="cell-participationCodeText" scope="props">
              <v-text nowrap>{{ props.item.application.participationCodeText }}</v-text>
            </template>
            <template slot="cell-amount" scope="props">
              <v-text nowrap>
                {{ props.item.application.amount ?
                  numberWithSpaces(props.item.application.amount) : '&mdash;' }}
              </v-text>
            </template>
            <template slot="cell-loanTypeText" scope="props">
              <v-text>{{ props.item.application.loanTypeText }}</v-text>
            </template>
            <template slot="cell-approvalEndDate" scope="props">
              <v-text nowrap>
                {{ props.item.application.approvalEndDate ?
                  moment(props.item.application.approvalEndDate).format('DD.MM.YYYY') : '&mdash;' }}
              </v-text>
            </template>
            <template slot="cell-sourceCodeText" scope="props">
              <v-text>{{ props.item.application.sourceCodeText }}</v-text>
            </template>
          </v-data-table>

          <v-data-table v-if="selectedTab == 'prohibitions'" @sort="$emit('sort', $event)" :sort="sort"
            :headers="prohibitionHeaders" :records="events" rowAction>

            <template slot="cell-name" scope="props">
              <v-text>{{ props.item.name || 'Самозапрет' }}</v-text>
            </template>

            <template slot="cell-applicationDate" scope="props">
              <v-text nowrap>{{ props.item.prohibition && props.item.prohibition.date ?
                moment(props.item.prohibition.date).format('DD.MM.YYYY HH:mm') : '&mdash;' }}</v-text>
            </template>

            <template slot="cell-startDate" scope="props">
              <v-text nowrap>{{ props.item.prohibition && props.item.prohibition.startDate ?
                moment(props.item.prohibition.startDate).format('DD.MM.YYYY') : '&mdash;' }}</v-text>
            </template>

            <!-- Используем готовое описание из модели TypeText -->
            <template slot="cell-description" scope="props">
              <v-text>{{ props.item.prohibition && props.item.prohibition.typeText || '&mdash;' }}</v-text>
            </template>
          </v-data-table>
        </div>
      </section>
    </div>
  </v-modal>
</template>
<script>
import theme from "./ModalMonitoringEvent.scss";
import { numberWithSpaces } from '../../../helpers';
import moment from "moment";
export default {
  name: "modal-monitoring-event",
  props: {
    selectTab: Function,
    sort: Object,
    active: Boolean,
    event: Object,
    events: Array,
    theme: {
      type: Object,
      default() {
        return theme;
      }
    }
  },

  data() {
    return {
      tabs: {
        credits: {
          label: "Кредиты",
          active: true,
          selected: true
        },
        inquiries: {
          label: "Запросы",
          active: true
        },
        bankrupts: {
          label: "Банкротства",
          active: true
        },
        applications: {
          label: "Заявки",
          active: true
        },
        prohibitions: {
          label: "Самозапреты",
          active: true
        }
      },
      selectedTab: "credits",
      creditHeaders: {
        name: { label: "Событие" },
        date: { label: "Дата" },
        typeName: { label: "Вид кредита" },
        openDate: { label: "Дата открытия" },
        closePlanDate: { label: "Дата закрытия плановая" },
        closeFactDate: { label: "Дата закрытия фактическая" },
        status: { label: "Состояние счета" },
        pastDue: { label: "Просрочка" },
        limit: { label: "Балансы" }
      },
      inquiryHeaders: {
        name: { label: "Событие" },
        date: { label: "Дата" },
        purposeName: { label: "Цель" },
        amount: { label: "Сумма" }
      },
      bankruptHeaders: {
        name: { label: "Событие" },
        date: { label: "Дата" },
        codeText: { label: "Статус дееспособности" },
        stageText: { label: "Стадия рассмотрения" },
        number: { label: "Номер судебного акта" }
      },
      applicationHeaders: {
        name: { label: "Событие" },
        date: { label: "Дата" },
        contactingCodeText: { label: "Способ обращения" },
        stageText: { label: "Стадия рассмотрения" },
        participationCodeText: { label: "Вид участия в сделке" },
        amount: { label: "Сумма займа" },
        loanTypeText: { label: "Вид займа" },
        approvalEndDate: { label: "Дата окончания действия одобрения" },
        sourceCodeText: { label: "Источник" }
      },
      prohibitionHeaders: {
        name: { label: "Событие" },
        applicationDate: { label: "Дата подачи заявления" },
        startDate: { label: "Дата начала действия" },
        description: { label: "Описание запрета" }
      }
    };
  },
  methods: {
    numberWithSpaces,
    changeTab(tab) {
      this.selectedTab = tab;
      this.selectTab(tab);
    },
    moment,
    formatItemName(itemName) {
      switch (itemName) {
        case "Запрос КИ":
          return "Запрос кредитной истории";
        case "Запрос «Изменение текущей задолженности более чем на n%":
          return "Запрос «Изменение текущей задолженности более чем на 50%";
        default:
          return itemName;
      }
    },
    formatInquiryCode(code) {
      switch (code) {
        case 1:
          return "Автокредит";
        case 4:
          return "Лизинг";
        case 6:
          return "Ипотека";
        case 7:
          return "Кредитная карта";
        case 9:
          return "Потребительский кредит";
        case 10:
          return "На развитие бизнеса";
        case 11:
          return "На увеличение оборотных средств";
        case 12:
          return "На приобретение оборудования";
        case 13:
          return "На строительство недвижимости";
        case 14:
          return "На покупку ценных бумаг";
        case 15:
          return "Межбанковский кредит";
        case 16:
          return "Микрокредит";
        case 17:
          return "Овердрафт кредитной карты";
        case 18:
          return "Овердрафт";
        case 50:
          return "Просмотр кредитной истории";
        case 99:
          return "Неизвестно";

        default:
          break;
      }
    },

    formatMopCode(text, code) {
      let str;
      if (code === "0") {
        return (str = "Отсутсвует");
      }
      return (str = text);
    },

    getFullName({ lastName, firstName, middleName }) {
      function toUpper(word) {
        if (!word) return '';
        const w = word.toLowerCase();
        return w.charAt(0).toUpperCase() + w.substring(1);
      }
      return `${toUpper(lastName)} ${toUpper(firstName)} ${toUpper(
        middleName
      )}`;
    },

    formatBirthDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    formatMonitoringEndDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${year}`;
    },
  },
  watch: {
    selectedTab(newVal) {
      if (newVal) {
        this.selectedTab = newVal;
      }
    }
  },
  computed: {
    currentMonitoringEnd() {
      return this.event ? this.formatMonitoringEndDate(this.event.monitoringEnd) : '';
    },
  }
};
</script>


// WEBPACK FOOTER //
// ModalMonitoringEvent.vue?51b2497e